import {v4} from "uuid";
import i18n from "@/i18n";
const notifications = {
    state: () => ({
        messages: [
        ]
    }),
    getters: {
        MESSAGES(state) {return state.messages},
    },
    mutations: {
        setNotice (state, payload) {
            state.messages.unshift(payload)
        },
        delNotice(state, index) {
            state.messages.splice(index, 1)
        },
        clearAllNotice(state) {
            state.messages = []
        },
        autoDelNotice(state, payload) {
            setTimeout(() => {
                state.messages.splice(payload.index, 1)
            }, payload.time)
        }
    },
    actions: {
        addNewNotice({state, commit, dispatch}, payload) {
            // console.log(payload)
            let text, code
            if (payload.error && payload.text.response?.status < 500) {
                text = payload.text.response?.data.message || payload.text.response?.data.Message || 'Ошибка' // отрабатывает не на все запросы!!!
                code = payload.text.response?.request.responseURL
                payload.text = text
                payload.code = code
            } else if (payload.error && payload.text.response?.status === 500) {
                text = i18n.global.t('notifications.error')
                code = i18n.global.t('notifications.idError') +  payload.text.response.data['error_id']
                payload.text = text
                payload.code = code
            }
            payload.id = v4()
            commit('setNotice', payload)
            let time = 0
            payload.error ? time = 15000 : time = 3000 //если ошибка то автоудалние через 15 сек, если не ошибка то 3 сек.
            let idsNotice = Array.from(state.messages, (x) => x.id)
            let index = idsNotice.indexOf(payload.id)
            commit('autoDelNotice', {index, time})
        }
    }
}
export {notifications}
